import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
export default (function () { return (React.createElement(Box, { display: "flex", height: "100vh", margin: "0", justifyContent: "center", alignItems: "center", "aria-label": "progContainer" },
    React.createElement(CircularProgress, null))); });
//# sourceMappingURL=LoadingBox.js.map